
import ListOffers from "../../Components/Offers/ListOffers"

export default function OffersPage() {
    return (
        <>
            <ListOffers />
        </>
    )
}